import React from 'react';
import { useSelector } from 'react-redux';
import FrequencyAndDuration from '../components/frequencyAndDuration';
import StepWrapper from '../components/stepWrapper';
import Age from '../steps/age';
import WithOneOption from '../steps/withOneOption';
import { MultiOptions } from '../steps/multiOptions';
import { MultiOptionsColored } from '../steps/multiOptionsColored';
import Mail from '../steps/mail';
import Diet from '../steps/diet';
import BodyMass from '../steps/extra/bodyMass';
import Fat from '../steps/extra/fat';
import Map from '../steps/extra/map';
import WorkoutsPreferences from '../steps/extra/workoutsPreferences';
import BeforeAfter from '../steps/extra/beforeAfter';
import Caffeine from '../steps/info/caffeine';
import NutritionExperts from '../steps/info/nutrition_experts';
import QuitExercising from '../steps/info/quit_exercising';
import Trainers from '../steps/info/trainers';
import MedicineExperts from '../steps/info/medicine_experts';
import ValueAndUnits from '../steps/valueAndUnits';
import ValueAndUnitsHeight from '../steps/valueAndUnitsHeight';
import BeforeAfterB from '../steps/extra/beforeAfterB';
import XmasStartScreen from '../steps/extra/xmasStartScreen';
import BigPhotoStartScreen from '../steps/extra/bigPhotoStartScreen';
import AgeGroupStartScreen from '../steps/extra/ageGroupStartScreen';
import NewYearStartScreen from '../steps/extra/newYearStartScreen';
import Habbits from '../steps/extra/habbits';
import TitlePictureQuestions from '../steps/titlePictureQuestions';
import kidImg from './img/stepsImages/kid.png';
import female1 from './img/stepsImages/female-1.png';
import male1 from './img/stepsImages/male-1.png';
import postCovidMale from './img/stepsImages/post-covid-male.png';
import postCovidFemale from './img/stepsImages/post-covid-female.png';
import steps from './steps';
import BeforeAfterC from '../steps/extra/beforeAfterC';
import getParameterFromURL from '../utils/scripts/getParameterFromURL';

export const stepsComponents = {
	age: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'age',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<Age />
		</StepWrapper>
	),
	gender: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'gender',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<WithOneOption />
		</StepWrapper>
	),
	goal: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'goal',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<MultiOptions />
		</StepWrapper>
	),
	goalB: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'goalB',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<WithOneOption />
		</StepWrapper>
	),
	goal_three: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'goal_three',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<WithOneOption />
		</StepWrapper>
	),
	activities_preferences: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'activities_preferences',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<MultiOptions />
		</StepWrapper>
	),
	diet_type: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'diet_type',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<Diet />
		</StepWrapper>
	),
	current_level: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'current_level',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<WithOneOption />
		</StepWrapper>
	),
	zones: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'zones',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<MultiOptions designExpanded />
		</StepWrapper>
	),
	motivation: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'motivation',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<MultiOptions />
		</StepWrapper>
	),
	frequency: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'frequency',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<WithOneOption />
		</StepWrapper>
	),
	duration: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'duration',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<WithOneOption />
		</StepWrapper>
	),
	sleep: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'sleep',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<WithOneOption />
		</StepWrapper>
	),
	water: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'water',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<WithOneOption />
		</StepWrapper>
	),
	motivation_rate: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'motivation_rate',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<WithOneOption />
		</StepWrapper>
	),
	life_changes: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'life_changes',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<WithOneOption />
		</StepWrapper>
	),
	last_time_ideal_weight: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'last_time_ideal_weight',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<WithOneOption />
		</StepWrapper>
	),
	frequency_and_duration: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[
				{
					name: 'frequency',
					isCompleted: 'ifAtLeastThreeAnswerSelected'
				},
				{
					name: 'duration',
					isCompleted: 'ifOneAnswerSelected'
				}
			]}
		>
			<FrequencyAndDuration />
		</StepWrapper>
	),
	weight: (stepData) => {
		const validationValues = {
			lbs: {
				bottom: 60,
				top: 500
			},
			kg: {
				bottom: 30,
				top: 299
			}
		};

		const showWeightRecommendations = false;

		return (
			<StepWrapper
				stepData={stepData}
				stepsType={steps}
				customIsCompletedValidation
			>
				<ValueAndUnits
					validationValues={validationValues}
					questionName="weight"
					inputId="weight"
					stepName="weight"
					units={['lbs', 'kg']}
					defaultUnits="lbs"
					inputStyle="plain"
					showWeightRecommendations={showWeightRecommendations}
				/>
			</StepWrapper>
		);
	},
	target_weight: (stepData) => {
		const validationValues = {
			lbs: {
				bottom: 60,
				top: 500
			},
			kg: {
				bottom: 30,
				top: 299
			}
		};

		const AdQ = getParameterFromURL('config') === 'AdQ';
		const showWeightRecommendations = !AdQ || false;

		return (
			<StepWrapper
				stepData={stepData}
				stepsType={steps}
				customIsCompletedValidation
			>
				<ValueAndUnits
					validationValues={validationValues}
					questionName="target_weight"
					inputId="target_weight"
					stepName="target_weight"
					units={['lbs', 'kg']}
					defaultUnits="lbs"
					inputStyle="plain"
					showWeightRecommendations={showWeightRecommendations}
				/>
			</StepWrapper>
		);
	},
	height: (stepData) => {
		const validationValues = {
			ft: {
				bottom: 3,
				top: 6
			},
			cm: {
				bottom: 90,
				top: 290
			}
		};

		return (
			<StepWrapper
				stepData={stepData}
				stepsType={steps}
				customIsCompletedValidation
			>
				<ValueAndUnitsHeight
					validationValues={validationValues}
					questionName="height"
					stepName="height"
					singleWarning
					units={['ft', 'cm']}
					defaultUnits="ft"
					inputStyle="plain"
				/>
			</StepWrapper>
		);
	},
	mail: (stepData) => {
		const planMan = useSelector((state) => state.global.planMan);
		const inputStyle = planMan ? 'fullBorder' : 'plain';

		return (
			<StepWrapper
				stepData={stepData}
				stepsType={steps}
				customIsCompletedValidation
			>
				<Mail inputStyle={inputStyle} />
			</StepWrapper>
		);
	},
	nutrition_approaches: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'nutrition_approaches',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<MultiOptions resetIfValueSelected="none" />
		</StepWrapper>
	),
	physicall_active: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'physicall_active',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<WithOneOption />
		</StepWrapper>
	),
	exercises_time: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'exercises_time',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<WithOneOption />
		</StepWrapper>
	),
	successfully_lost_weight: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'successfully_lost_weight',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<WithOneOption />
		</StepWrapper>
	),
	emotional_eating: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'emotional_eating',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<WithOneOption />
		</StepWrapper>
	),
	diseases: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'diseases',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<MultiOptions resetIfValueSelected="none" />
		</StepWrapper>
	),
	health_issues: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'health_issues',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<MultiOptions resetIfValueSelected="none" />
		</StepWrapper>
	),
	body_type: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			design="imgAtRightSide"
			questions={[{
				name: 'body_type',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<WithOneOption />
		</StepWrapper>
	),
	medications: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'medications',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<MultiOptions resetIfValueSelected="none" />
		</StepWrapper>
	),
	devices: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'devices',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<MultiOptions resetIfValueSelected="none" />
		</StepWrapper>
	),
	previous_fails: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'previous_fails',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<MultiOptions resetIfValueSelected="none" />
		</StepWrapper>
	),
	motivates_exercise: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'motivates_exercise',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<MultiOptions resetIfValueSelected="none" />
		</StepWrapper>
	),
	focus: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'focus',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<MultiOptions resetIfValueSelected="none" />
		</StepWrapper>
	),
	body_mass: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			customIsCompletedValidation
		>
			<BodyMass />
		</StepWrapper>
	),
	caffeine: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			customIsCompletedValidation
		>
			<Caffeine />
		</StepWrapper>
	),
	nutrition_experts: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			customIsCompletedValidation
		>
			<NutritionExperts />
		</StepWrapper>
	),
	quit_exercising: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			customIsCompletedValidation
		>
			<QuitExercising />
		</StepWrapper>
	),
	habbits: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			customIsCompletedValidation
		>
			<Habbits />
		</StepWrapper>
	),
	trainers: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			customIsCompletedValidation
		>
			<Trainers />
		</StepWrapper>
	),
	medicine_experts: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			customIsCompletedValidation
		>
			<MedicineExperts />
		</StepWrapper>
	),
	map: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			customIsCompletedValidation
		>
			<Map />
		</StepWrapper>
	),
	workouts_preferences: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			customIsCompletedValidation
		>
			<WorkoutsPreferences />
		</StepWrapper>
	),
	fat: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			customIsCompletedValidation
		>
			<Fat />
		</StepWrapper>
	),
	before_after: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			customIsCompletedValidation
		>
			<BeforeAfter />
		</StepWrapper>
	),
	before_after_b: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			customIsCompletedValidation
		>
			<BeforeAfterB />
		</StepWrapper>
	),
	before_after_c: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			customIsCompletedValidation
		>
			<BeforeAfterC />
		</StepWrapper>
	),
	big_photo_start_screen: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			customIsCompletedValidation
		>
			<BigPhotoStartScreen />
		</StepWrapper>
	),
	age_group_start_screen: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			customIsCompletedValidation
		>
			<AgeGroupStartScreen />
		</StepWrapper>
	),
	colored_options_start_screen: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'colored_options_start_screen',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<MultiOptionsColored />
		</StepWrapper>
	),
	zones_start_screen: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'zones_start_screen',
				isCompleted: 'ifOneAnswerSelected'
			}]}
		>
			<MultiOptions squareStyle />
		</StepWrapper>
	),
	xmas_start_screen: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			customIsCompletedValidation
		>
			<XmasStartScreen />
		</StepWrapper>
	),
	new_year_start_screen: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			customIsCompletedValidation
		>
			<NewYearStartScreen />
		</StepWrapper>
	),
	kids: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'kids',
				isCompleted: 'ifOneAnswerSelected'
			}]}
			stepImg={
				{
					forAllGenders: {
						img: kidImg,
						styles: {
							width: '202px',
							marginTop: '-30px',
							marginBottom: '-65px'
						}
					}
				}
			}
		>
			<TitlePictureQuestions />
		</StepWrapper>
	),
	noise_free: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'noise_free',
				isCompleted: 'ifOneAnswerSelected'
			}]}
			stepImg={
				{
					female: {
						img: female1,
						styles: {
							width: '260px',
							marginTop: '-30px',
							marginBottom: '-35px'
						}
					},
					male: {
						img: male1,
						styles: {
							width: '271px',
							marginTop: '-30px',
							marginBottom: '-60px'
						}
					}
				}
			}
		>
			<TitlePictureQuestions />
		</StepWrapper>
	),
	post_covid: (stepData) => (
		<StepWrapper
			stepData={stepData}
			stepsType={steps}
			questions={[{
				name: 'post_covid',
				isCompleted: 'ifOneAnswerSelected'
			}]}
			stepImg={
				{
					female: {
						img: postCovidFemale,
						styles: {
							width: '260px',
							marginTop: '-30px',
							marginBottom: '-60px'
						}
					},
					male: {
						img: postCovidMale,
						styles: {
							width: '273px',
							marginTop: '-30px',
							marginBottom: '-60px'
						}
					}
				}
			}
		>
			<TitlePictureQuestions />
		</StepWrapper>
	)
};
